import BetModel from "slotworks/model/bets/bet-model";
import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class SpinRequestPayload extends RequestPayload {
    public lines: number[] = BetModel.getSelectedLineIds();
    public stakePerLine: number = BetModel.getBetPerLine();
    public coinSize: number = BetModel.getCoinSize();
}



// WEBPACK FOOTER //
// ./~/slotworks/model/gameplay/requests/spin-request-payload.ts